// Self-contained data for the SCALE Documentation Services concept website.
// Sourced from MySiteCare_PH_Law_Accounting_Prospect_Dossiers_WIP/01_SCALE_Documentation_Services (research snapshot 2026-08-21).
// Owner/founding attorney/notary is NOT reliably identified in public sources — do not invent a name.
// No individually-readable review body was recovered — aggregate rating only, no invented testimonials.
export const BIZ = {
  name: "SCALE Documentation Services",
  fullName: "SCALE Documentation Services (Law Office & Notary Public)",
  tagline: "Fast, Clear Document Preparation & Notarial Services in Makati",
  address: "Unit 6H, 6th Floor, Cityland Herrera Tower, V.A. Rufino cor. Valero, Makati City 1227",
  phone: "+63285602793",
  phoneDisplay: "+63 2 8560 2793",
  mapEmbed: "https://www.google.com/maps?q=Cityland+Herrera+Tower+V.A.+Rufino+Valero+Makati+City&output=embed",
};

export const SERVICES = [
  { title: "Legal Documentation", text: "Preparation of legal documents for individuals and businesses." },
  { title: "Notarial Services", text: "Notarization of documents by a notary public." },
  { title: "Contracts & Agreements", text: "Drafting and review of contracts and agreements." },
  { title: "General Legal-Document Assistance", text: "General help with legal-document needs in Makati CBD." },
];

export const WHAT_TO_BRING = [
  "A valid government-issued ID",
  "The document(s) you need prepared or notarized",
  "Any co-signatories present, if the document requires more than one signature",
];

export const HOW_IT_WORKS = [
  { n: "1", title: "Call Ahead", text: "Call us to confirm what's needed for your specific document." },
  { n: "2", title: "Visit the Office", text: "Come to our Makati CBD office with your document and valid ID." },
  { n: "3", title: "Review", text: "We review your document for completeness before notarization." },
  { n: "4", title: "Notarized", text: "Sign in front of the notary public and receive your notarized document." },
];

export const FAQ = [
  { q: "Do I need an appointment?", a: "Call us ahead of your visit to confirm current requirements and availability." },
  { q: "What should I bring?", a: "A valid government ID and the document itself. Additional signatories should bring their own valid ID." },
  { q: "Where is the office?", a: "6th Floor, Cityland Herrera Tower, V.A. Rufino corner Valero, Makati City — inside the Makati CBD." },
];

// Aggregate rating only. Current structured listing shows 5.0★ / 543 reviews; older
// public mirrors showed 435–447, so the exact count varies by crawl date. No individual
// review body was recoverable — do not present invented testimonial text.
export const REPUTATION = {
  rating: "5.0",
  reviewCountLabel: "500+ public reviews",
  note: "Review counts vary slightly by listing and crawl date (543 in the most current structured listing; 435–447 in earlier mirrors).",
};
